import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import "modules/CommunicationSettings/CustomerCom.scss";

import type { CommunicationSetting } from "models";

type OnlineCheckInProps = {
  tabId: string;
  dmsDateRange?: number;
};

const FormHelper = createFormHelper<CommunicationSetting>();

export const OnlineCheckIn = ({ tabId, dmsDateRange }: OnlineCheckInProps) => {
  const { t } = useTranslation();
  const checkInDaysPrior = FormHelper.useWatch("check_in_days_prior");

  const isDaysPriorTooHigh = dmsDateRange !== undefined && checkInDaysPrior >= dmsDateRange;

  return (
    <Element name={tabId} className="customer-com-wrapper">
      <h3>{t("v8_online_check_in", "Online check-in")}</h3>
      <div>
        <Form.Group className="mt-16">
          <Form.Field width={3}>
            <span className="items-center">
              <FormHelper.Field.Checkbox name="check_in_testing_mode" label={t("v8_testing_mode", "Testing mode")} />
            </span>
          </Form.Field>
          <Form.Field width={5}>
            <label>{t("v8_email", "E-mail")}</label>
            <FormHelper.Field.Input inputProps={{ placeholder: t("v8_email", "E-mail"), fluid: true }} name="check_in_testing_email" />
          </Form.Field>
          <Form.Field width={8}>
            <label>{t("v8_phone", "Phone")}</label>
            <FormHelper.Field.Input inputProps={{ placeholder: t("v8_phone", "Phone"), fluid: true, type: "Phone" }} name="check_in_testing_phone" />
          </Form.Field>
        </Form.Group>

        <Form.Group className="mt-16">
          <Form.Field width={8}>
            <label>{t("v8_welcome_text", "Welcome text")}</label>
            <FormHelper.Field.TextArea name="check_in_welcome_text" textAreaProps={{ placeholder: `${t("v8_hello", "Hello")}!` }} />
          </Form.Field>

          <Form.Field width={8}>
            <label>{t("v8_success_text", "Success text")}</label>
            <FormHelper.Field.TextArea name="check_in_success_text" textAreaProps={{ placeholder: `${t("v8_thank_you")}` }} />
          </Form.Field>
        </Form.Group>

        <Form.Group className="mt-14">
          <Form.Field width={8} className="pr-12" error={isDaysPriorTooHigh}>
            <label>{t("v8_days_prior_to_appointment", "Send how many days prior to the appointment date")}</label>
            <FormHelper.Field.Input inputProps={{ placeholder: "7", fluid: true, type: "number" }} name="check_in_days_prior" />
            {isDaysPriorTooHigh && (
              <div className="field-error">
                {t("v8_must_be_lower_than_dms_date_range", "Must be lower than the DMS date range ({{date_range}})", { date_range: dmsDateRange })}
              </div>
            )}
          </Form.Field>
        </Form.Group>

        <Form.Group className="mt-24">
          <Form.Field width={8}>
            <span className="items-center">
              <FormHelper.Field.Checkbox name="checkin_remarks_enabled" label={t("v8_enable_remarks", "Enable remarks")} />
            </span>
          </Form.Field>

          <Form.Field width={8}>
            <span className="items-center">
              <FormHelper.Field.Checkbox name="online_check_in_name_visible" label={t("v8_ask_customer_enter_name", "Ask the Customer to enter his name")} />
            </span>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field width={8}>
            <span className="items-center">
              <FormHelper.Field.Checkbox name="online_check_in_send_pin" label={t("v8_key_locker_pin_for_checkin", "Send Key Locker PIN in Online check-in")} />
            </span>
          </Form.Field>

          <Form.Field width={8}>
            <span className="items-center">
              <FormHelper.Field.Checkbox
                name="block_automated_communication_for_lease_customer"
                label={t("v8_online_checkin_lease_customer", "Do not send Online check-in or other automated mail to Lease customer")}
              />
            </span>
          </Form.Field>
        </Form.Group>

        <Form.Group>
          <Form.Field width={8}>
            <span className="items-center">
              <FormHelper.Field.Checkbox name="send_parking_gate_code" label={t("v8_send_parking_gate_code", "Send parking gate code")} />
            </span>
          </Form.Field>
        </Form.Group>
      </div>
    </Element>
  );
};
